<template>
  <div class="country-group" :id="`group_${name}`">
    <div class="country-group-label">{{name}}</div>
    <div class="country-container">
    <slot>

    </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CountryGroup',
  props: ["name"],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.country-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  width: 100%;
  max-width: 200px;
}

.country-group > .country-group-label {
  font-size: 24px;
  font-weight: bold;
  width: 50px;
  margin-bottom: 10px;
}

@media all and (max-width:480px) {
  .country-group {
    max-width: 150px;
  }
}
</style>
